import { useEffect, useState } from "react";
import { PostHogProvider } from "posthog-js/react";
import { useDispatch, useSelector } from "react-redux";
import { getCmsContent } from "../../redux/actions/productTourActions";
import { logoutCall } from "../../redux/actions/authActions";

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

const ProductUpdates = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth?.user);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const [teamMemberChannel, setTeamMemberChannel] = useState(null);

  const customSenderId = user?.custom_user_id;
  const isTeamMemberAccount =
    user?.role?.key?.length > 0 && customSenderId?.length > 0;

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getCmsContent());
    }
  }, [user, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && isTeamMemberAccount) {
      let pusher = new window.Pusher(import.meta.env.VITE_PUSHER_APP_KEY, {
        cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
      });

      let channel = pusher.subscribe(`team-member-${customSenderId}`);

      setTeamMemberChannel(channel);

      return () => setTeamMemberChannel(null);
    }
  }, [isAuthenticated, isTeamMemberAccount]);

  // * Listen for delete-member event for whatsapp_agent_session_window channel
  // * for showing warning alert banner
  const handleLogout = (data) => {
    // data = { is_active: true/false }
    if (data?.is_active === false) dispatch(logoutCall());
  };

  useEffect(() => {
    const eventName = `delete-member`;
    const eventHandler = (data) => handleLogout(data);

    if (teamMemberChannel && teamMemberChannel.bind)
      teamMemberChannel.bind(eventName, eventHandler);

    return () => {
      if (teamMemberChannel && teamMemberChannel.unbind)
        teamMemberChannel.unbind(eventName, eventHandler);
    };
  }, [teamMemberChannel]);

  return (
    <>
      <PostHogProvider
        options={options}
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      >
        {children}
      </PostHogProvider>
    </>
  );
};

export default ProductUpdates;
